var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
var BluaBlueNodeSdk = /** @class */ (function () {
    function BluaBlueNodeSdk(PublicId, APIkey, endpoint, apiVersion) {
        var _this = this;
        if (PublicId === void 0) { PublicId = null; }
        if (APIkey === void 0) { APIkey = null; }
        if (endpoint === void 0) { endpoint = 'https://blua.blue'; }
        if (apiVersion === void 0) { apiVersion = 'v1'; }
        this.PublicId = PublicId || (typeof process !== 'undefined' ? process.env.BLUA_BLUE_PUBLIC_KEY : null);
        this.APIkey = APIkey || (typeof process !== 'undefined' ? process.env.BLUA_BLUE_PRIVATE_KEY : null);
        this.endpoint = endpoint;
        this.apiVersion = apiVersion;
        this.api = axios.create({
            baseURL: endpoint + '/api.' + apiVersion,
            headers: {}
        });
        this.api.interceptors.request.use(function (config) {
            if (_this.token) {
                config.headers.Authorization = "baerer " + _this.token;
            }
            return config;
        });
    }
    BluaBlueNodeSdk.prototype.authenticate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post('/auth/' + this.PublicId, { apiKey: this.APIkey }).then(function (res) {
                        _this.token = res.data.token;
                    }).catch(BluaBlueNodeSdk.evaluateError)];
            });
        });
    };
    BluaBlueNodeSdk.prototype.getToken = function () {
        return this.token;
    };
    BluaBlueNodeSdk.prototype.setToken = function (token) {
        this.token = token;
    };
    BluaBlueNodeSdk.prototype.login = function (redirect, scope, endpoint) {
        if (scope === void 0) { scope = 'all'; }
        if (endpoint === void 0) { endpoint = null; }
        return this.endpoint + ("/auth?scope=" + scope + "&public_key=" + this.PublicId + "&redirect=") + redirect + (endpoint ? '&endpoint=' + endpoint : '');
    };
    BluaBlueNodeSdk.prototype.getArticle = function (slug) {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get('/article/slug/' + slug)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        e_1 = _a.sent();
                        BluaBlueNodeSdk.evaluateError(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BluaBlueNodeSdk.prototype.getOwnArticles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get('/article/mine')];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        e_2 = _a.sent();
                        BluaBlueNodeSdk.evaluateError(e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BluaBlueNodeSdk.prototype.updateArticle = function (article) {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.put('/article', article)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        e_3 = _a.sent();
                        BluaBlueNodeSdk.evaluateError(e_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BluaBlueNodeSdk.prototype.createArticle = function (article) {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post('/article', article)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        e_4 = _a.sent();
                        BluaBlueNodeSdk.evaluateError(e_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BluaBlueNodeSdk.prototype.getImages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get('/image')];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        e_5 = _a.sent();
                        BluaBlueNodeSdk.evaluateError(e_5);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BluaBlueNodeSdk.prototype.registerImage = function (image, mode) {
        if (mode === void 0) { mode = 'external'; }
        return __awaiter(this, void 0, void 0, function () {
            var data, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post('/image', { mode: mode, image: image })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        e_6 = _a.sent();
                        BluaBlueNodeSdk.evaluateError(e_6);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BluaBlueNodeSdk.prototype.deleteImage = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.delete('/image/' + id)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        e_7 = _a.sent();
                        BluaBlueNodeSdk.evaluateError(e_7);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BluaBlueNodeSdk.prototype.getCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get('/category')];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        e_8 = _a.sent();
                        BluaBlueNodeSdk.evaluateError(e_8);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BluaBlueNodeSdk.prototype.getAccountInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get('/profile-settings')];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2:
                        e_9 = _a.sent();
                        BluaBlueNodeSdk.evaluateError(e_9);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BluaBlueNodeSdk.evaluateError = function (error) {
        throw new Error("Failed to execute method - " + error);
    };
    return BluaBlueNodeSdk;
}());
export default BluaBlueNodeSdk;
//# sourceMappingURL=index.js.map